import { AnyAction } from 'redux';
import { TrackingEvent } from '@bridebook/web/lib/track-utils/tracking-event';

export interface ITrackEventAction<P> {
  type: typeof trackEventType;
  payload: P;
  event: TrackingEvent;
  fireOnce?: true;
}

export const trackEvent = <P>(
  event: TrackingEvent,
  payload: P,
  fireOnce?: true,
): ITrackEventAction<P> => ({
  type: trackEventType,
  payload,
  event,
  fireOnce,
});

export const trackEventType = 'TRACK_EVENT';
export const isTrackingAction = (action: AnyAction): action is ITrackEventAction<unknown> =>
  action.type === trackEventType;
